export default __webpack_public_path__ + "static/media/warning--roundabout--g6.73900945.png";